import { Inject, Injectable, DOCUMENT } from "@angular/core";

@Injectable({ providedIn: "root" })
export class PageClassService  {

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {}

    setPageClassFromUrl(url: string) {

        const firstRoutePart = /^\/?(\w+)/.exec(url)[1];

        const newClassList = [
            ...this.document.documentElement
                .className
                .split(" ")
                .filter(i => !!i && i.indexOf("page--") == -1),
            `page--${firstRoutePart}`,
        ];

        this.document.documentElement.className = newClassList.join(" ");

        return true;
    }
}
